import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';

import { IItemGroupProps } from '../types';
import { Icons, Tooltip } from 'src/components';
import GroupEntries from './GroupEntries';

const ItemGroup: React.FC<IItemGroupProps> = ({
  itemGroup,
  index,
  removeGroup,
  setGroupName,
  toggleGroupExpand,
}) => {
  const onNameChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    setGroupName(event.currentTarget.value);
  };
  return (
    <Draggable draggableId={String(itemGroup.id)} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`border-t border-grey-dark py-2 px-4 mb-1 ${
            snapshot.isDragging ? 'bg-grey shadow-lg' : ''
          }`}
        >
          <div className="flex items-center mb-2">
            <input
              value={itemGroup.name}
              placeholder="Set group name"
              className="group-name-input flex-1 mr-3"
              onChange={onNameChange}
              required={true}
            />
            <Tooltip
              className="ml-4 mr-3"
              text={itemGroup.isExpanded ? 'Collapse' : 'Expand'}
            >
              <button type="button" className="p-2" onClick={toggleGroupExpand}>
                <Icons.CaretDown
                  size={18}
                  className={itemGroup.isExpanded ? 'flip-y' : ''}
                />
              </button>
            </Tooltip>
            <Tooltip text={'Delete'}>
              <button type="button" onClick={removeGroup}>
                <Icons.Circle character={'×'} color="#474F54" />
              </button>
            </Tooltip>
            <div className="pl-3 py-2 pr-2" {...provided.dragHandleProps}>
              ↕
            </div>
          </div>
          <GroupEntries
            hidden={!itemGroup.isExpanded}
            groupId={itemGroup.id}
            items={itemGroup.items}
          />
        </div>
      )}
    </Draggable>
  );
};

export default ItemGroup;



// WEBPACK FOOTER //
// ./src/views/Admin/ItemGroups/components/ItemGroup.tsx